<template>
  <div>
    <div class="main-title">按单据返现(计费套餐)
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <!--
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="训练日期"
              end-placeholder="训练日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="单据编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              style="width:120px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="教练姓名"
              v-model="searchForm.coach_name"
              prefix-icon="el-icon-search"
              clearable
              style="width:120px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.return_status" placeholder="返现状态" style="width:120px;" @change="search(searchParams)">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="未返现" value="未返现"></el-option>
              <el-option label="已返现" value="已返现"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="195">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="优惠"
          width="70">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="return_fee"
          label="符合条件的金额"
          width="140">
        </el-table-column>
        <el-table-column
          label="可返金额"
          width="80">
          <template slot-scope="scope">
            {{ scope.row.fee_package_count * 50 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="pay_status"
          label="支付状态"
          width="80">
        </el-table-column>
        <el-table-column
          prop="status"
          label="单据状态"
          width="80">
        </el-table-column>
        <el-table-column
          prop="return_status"
          label="返现状态"
          width="80">
        </el-table-column>
        <el-table-column
          prop="return_time"
          label="返现时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="return_money"
          label="已返金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="return_oper_name"
          label="操作员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="140">
        </el-table-column>
        <el-table-column
          prop="pay_cash"
          label="现金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_alipay"
          label="支付宝"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_wechat"
          label="微信支付"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_pos"
          label="银行卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_balance"
          label="充值卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_coupon"
          label="代金券"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'">
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="150">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" v-if="showReturnButton(scope.row)" @click="ret(scope.row)">点击返现</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <el-dialog :title="'返现:' + form.bill_no" :visible.sync="formVisible">
        <el-form :model="form" ref="form" :rules="formRules" label-width="120px">
          <el-form-item label="支出项目" prop="fin_item">
            <el-col :span="11">
              <el-select v-model="form.fin_item" placeholder="请选择项目" style="width:100%">
                <el-option v-for="i in finItemList" :key="i.id" :label="i.item_name" :value="i.item_name"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-input v-model="form.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="支出金额" prop="fin_money">
            <el-col :span="11">
              <el-input v-model.number="form.fin_money" disabled></el-input>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-input v-model="form.fin_person" placeholder="收款人"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-col :span="11">
              <el-select v-model="form.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
                <el-option label="现金" value="现金"></el-option>
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option label="微信支付" value="微信支付"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="转账" value="转账"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-form-item prop="fin_account">
                <el-select v-model="form.fin_account" placeholder="请选择账户" style="width:100%">
                  <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" autosize placeholder="备注(可以不填)"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="commit" :loading="commiting">确 定</el-button>
          <el-button @click="formVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    user: Object
  },
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      billList: [],
      sqlcode: 'bill_list_ret_package',
      searchForm: {
        company_ids: [],
        query: '',
        coach_name: '',
        daterange: [
          // new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          // this.user.buttons.indexOf(1020) < 0 ? new Date() : new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
          // new Date()
        ],
        return_status: null
      },
      form: {
        ids: 0,
        bill_no: '',
        fin_type: '0',
        fin_item: '',
        pay_type: '现金',
        fin_account: 0,
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        remark: ''
      },
      formRules: {
        fin_item: [
          { required: true, message: '请选择项目', trigger: 'blur' }
        ],
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ],
        fin_money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      },
      formVisible: false,
      commiting: false,
      finItemList: [],
      accountList: [],
      companyList: []
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          coach_name: this.searchForm.coach_name,
          return_status: this.searchForm.return_status,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    },
    accountListFilter () {
      if (this.form.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.form.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.form.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.form.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (this.form.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return []
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchFinItemList()
    this.fetchAccountList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '作废' || row.status === '退款' || row.pay_status === '未支付') {
        return 'row-red'
      } else if (row.return_status === '已返现') {
        return 'row-green'
      } else {
        return ''
      }
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    fetchFinItemList () {
      this.$http.get('/dbapi/fin_item_combo').then(response => {
        if (response.data.success) {
          this.finItemList = response.data.list
          for (var i = 0; i < this.finItemList.length; i++) {
            if (this.finItemList[i].item_name.indexOf('返点') >= 0 || this.finItemList[i].item_name.indexOf('返现') >= 0) {
              this.form.fin_item = this.finItemList[i].item_name
              break;
            }
          }
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          for (var i = 0; i < this.accountList.length; i++) {
            if (this.accountList[i].account_type === '现金') {
              this.form.fin_account = this.accountList[i].id
              break;
            }
          }
        }
      })
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.form.fin_account = this.accountListFilter[0].id
      }
    },
    ret (row) {
      if (row.pay_status === '未支付') {
        this.$alert('账单是未支付状态，请先在账单记录中结算', '提示', {
          confirmButtonText: '我知道了'
        })
        return
      }
      this.form.ids = row.id
      this.form.bill_no = row.bill_no
      this.form.fin_money = row.fee_package_count * 50
      this.form.fin_person = row.coach_name
      this.form.remark = '单据编号:' + row.bill_no
      this.formVisible = true
    },
    commit: _.throttle(
      function () {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.commiting = true
            this.$http.post('/dbapi/return_cash_package', this.form).then(response => {
              this.commiting = false
              if (response.data.success) {
                this.formVisible = false
                this.refresh()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.$confirm('是否要现在打印支出证明单?', '提示', {
                  confirmButtonText: '现在打印',
                  cancelButtonText: '稍后打印',
                  type: 'warning'
                }).then(() => {
                  let url = '/expend_print'
                  if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
                    url = '/expend_print_1'
                  }
                  if ([2, 8].indexOf(this.user.group_id) >= 0) {
                    url = '/expend_print_blank'
                  }
                  window.open(this.$http.receiptBaseUrl + url + '?id=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
                })
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      2000
    ),
    showReturnButton (row) {
      if (row.status !== '正常') {
        return false
      } 
      if (row.pay_status !== '已支付') {
        return false
      } 
      if (row.return_status !== '未返现') {
        return false
      } 
      if (row.return_fee <= 0) {
        return false
      }
      if (row.company_id === 4) {
        if (row.end_time < '2021-01-30') {
          return false
        }
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/return/RetPackage.vue